import {GET_PIZZA_ORDERING_API, GET_QUICK_PIZZA_ORDERING_API} from "../constants/Ordering";
import {get} from "../helper";

export const getQuickPizzaOrdering = () => (dispatch) => {

    dispatch({type: GET_QUICK_PIZZA_ORDERING_API, loading: true});
    get('quickpizzaordering')
        .then(({data}) => {

            if (data) {
                dispatch({type: GET_QUICK_PIZZA_ORDERING_API, payload: data, loading: false});
            } else {
                dispatch({type: GET_QUICK_PIZZA_ORDERING_API, loading: false});
            }

        })
        .catch((error) => {

            dispatch({type: GET_QUICK_PIZZA_ORDERING_API, loading: false});
        });
};
export const getPizzaOrdering = () => (dispatch) => {

    dispatch({type: GET_PIZZA_ORDERING_API, loading: true});
    get('pizzaordering')
        .then(({data}) => {

            if (data) {
                dispatch({type: GET_PIZZA_ORDERING_API, payload: data, loading: false});
            } else {
                dispatch({type: GET_PIZZA_ORDERING_API, loading: false});
            }

        })
        .catch((error) => {

            dispatch({type: GET_PIZZA_ORDERING_API, loading: false});
        });
};